import React, { FC, ReactElement } from 'react';
import { withStyles } from '@mui/styles';
import { LngProps } from './mapTypes';
import styles from './pin-style';
import { IconCommon } from '../../resources/images';
import SvgIcon from '../icons/SvgIcon';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MeetingPointPinComponent: FC<LngProps> = ({ lat, lng, classes }): ReactElement => {
    return (
        <div>
            <SvgIcon icon={IconCommon.Pin} className={classes.pinPos} size="inherit" />
        </div>
    );
};

export default withStyles(styles)(MeetingPointPinComponent);
